<header class="header">
  <div class="row">
    <div class="col">
      <span class="fs-24 -50">Rox Forex Admin</span>
    </div>
    <div class="col-auto">
      <i class="fa fa-bars fs-24" role="button" (click)="toggleMenu()"></i>
    </div>
  </div>
</header>
